<!--
2023-05-24 Matt 常态化下注流水返利活动
-->
<template>
  <div class="earnDetailsPage">
    <TopBack :title="$t('lang.betActivityRegularly.details')" />
    <div class="earnTab">
      <div class="invite-tab">
        <div id="effective" class="tab-bk active" @click="effectiveClick">{{$t('lang.inviteFriends.valid')}}</div>
      </div>
      <div class="invite-tab">
        <div id="beConfirmed" class="tab-bk inactive" @click="beConfirmedClick">{{$t('lang.inviteFriends.invitations')}}</div>
      </div>
    </div>
    <div class="dataList">
      <div id="memos" class="memos">
        <Loadmore
          :bottomPullText="''"
          :bottomDropText="''"
          :bottomLoadingText="''"
          :auto-fill="true"
          :bottom-method="fetchData"
          :bottom-all-loaded="allLoaded"
          ref="loadMoreList"
        >
          <div class="memo" v-if="tabIndex===0" v-for="(item, index) in validList"  :key="index">
              <div class="item-title">
                <div class="item-name">{{item.Name}}</div>
                <div class="item-date">{{$t('lang.inviteFriends.lastOnline')}}{{item.LastOnline}}</div>
              </div>
              <div class="item-center">
                <div class="total-list" :style="subShow==='show'?'padding-right: 4vw;':''">
                  <div class="total-content">
                    <div class="TotalVal">{{item.TotalDepositAmount}}</div>
                    <div class="TotalTitle">{{$t('lang.history.Deposit')}}</div>
                  </div>
                  <div class="total-content">
                    <div class="TotalVal">{{item.TotalRebate}}</div>
                    <div class="TotalTitle">{{ $t('lang.agent.inviteRewards') }}</div>
                  </div>
                  <div class="total-content">
                    <div class="TotalVal">{{item.TotalBet}}</div>
                    <div class="TotalTitle">{{$t('lang.history.Bet')}}</div>
                  </div>
                  <div class="total-content" v-if="subShow==='show'">
                    <div class="TotalVal">{{ item.SubBetAmount }}</div>
                    <div class="TotalTitle">{{ $t('lang.inviteFriends.subBet') }}</div>
                  </div>
                </div>
                <div class="status"></div>
              </div>
          </div>
          <div class="memo" v-if="tabIndex===1" v-for="(item, index) in confirmList"  :key="index">
            <div class="item-title">
              <div class="item-name">{{item.Name}}</div>
              <div class="item-date">{{$t('lang.inviteFriends.InvitationDate')}}{{item.InvitationDate}}</div>
            </div>
            <div class="item-center">
              <div class="total-list" style="justify-content: space-between;width: 87vw;padding-right: 6.5vw;">
                <div class="total-content">
                  <div class="TotalVal">{{item.TotalBet}}</div>
                  <div class="TotalTitle">{{$t('lang.inviteFriends.TotalTitle1')}}</div>
                </div>
                <div class="total-content">
                  <div :class="status">{{getNotYetNums($t('lang.inviteFriends.notYet'))}}</div>
                </div>
              </div>
            </div>
          </div>
        </Loadmore>
      </div>
    </div>

  </div>
</template>

<script>
import {Loadmore} from 'mint-ui'
import request from '@/service'

import TopBack from '@/components/TopBack/index'

export default {
  name: 'EarnDetails',
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
      tabIndex: 0,
      subShow: 'hide',
      itemDate: 'item-dateEN',
      status: 'statusEN',
      validNum: -1,
      validList: [
        // {
        //   Name: 'inviteeName',
        //   TotalDeposit: 0,
        //   TotalRebate: 0,
        //   InvitationDate: '2025-07-31',
        //   TotalBet: '100',
        //   SubBetAmount: ''
        // }
      ],
      confirmNum: -1,
      confirmList: [
        // {
        //   Name: 'inviteeName',
        //   InvitationDate: '2025-07-31',
        //   TotalBet: '100'
        // }
      ],
      firstLoad: true,
      allLoaded: false,
      memos: []
    }
  },
  components: {
    Loadmore,
    TopBack
  },
  watch: {
    '$store.state.locale': function (n, o) {
      if (n === 'EN') {
        this.status = 'statusEN'
        this.itemDate = 'item-dateEN'
      } else if (n === 'IN') {
        this.status = 'statusIN'
        this.itemDate = 'item-dateIN'
      }
    }
  },
  mounted () {
    this.subShow = localStorage.getItem('subShow')
    if (this.$store.state.locale === 'EN') {
      this.status = 'statusEN'
      this.itemDate = 'item-dateEN'
    } else if (this.$store.state.locale === 'IN') {
      this.status = 'statusIN'
      this.itemDate = 'item-dateIN'
    }
    this.fetchData()
  },
  methods: {
    getNotYetNums (string) {
      if (string) {
        return string.replace('{nums}', 100)
      }
    },
    fetchData () {
      let that = this
      if (this.tabIndex === 0) {
        this.validNum++
        const url = '/innovation/invite_relation/get_valid_data'
        const data = {
          UserId: this.userInfo.UserId,
          PageNum: this.validNum
        }
        request('post', url, data).then(res => {
          if (res && res !== -1) {
            that.validList = that.validList.concat(res)
            if (res.length < 10) {
              that.allLoaded = true
            } else {
              that.allLoaded = false
            }
            if (!this.firstLoad) {
              this.$refs.loadMoreList.onBottomLoaded()
            }
            this.firstLoad = false
          }
        }).catch(err => {
          console.log(err)
        })
      } else if (this.tabIndex === 1) {
        this.confirmNum++
        const url = '/innovation/invite_relation/get_unconfirmed_data'
        const data = {
          UserId: this.userInfo.UserId,
          PageNum: this.confirmNum
        }
        request('post', url, data).then(res => {
          if (res && res !== -1) {
            // that.confirmList =  [
            //   {
            //     Name: 'inviteeName',
            //     InvitationDate: '2025-07-31',
            //     TotalBet: '100'
            //   }
            // ]
            that.confirmList = that.confirmList.concat(res)
            if (res.length < 10) {
              that.allLoaded = true
            } else {
              that.allLoaded = false
            }
            if (!this.firstLoad) {
              this.$refs.loadmore.onBottomLoaded()
            }
            this.firstLoad = false
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    changeLocale () {
    },
    effectiveClick () {
      if (this.tabIndex === 1) {
        let obj = document.getElementById('effective')
        let obj2 = document.getElementById('beConfirmed')
        obj.setAttribute('class', 'tab-bk active')
        obj2.setAttribute('class', 'tab-bk inactive')
        this.tabIndex = 0
        this.validNum = -1
        this.validList = []
        this.confirmList = []
        this.firstLoad = true
        this.fetchData()
      }
    },
    beConfirmedClick () {
      if (this.tabIndex === 0) {
        let obj = document.getElementById('beConfirmed')
        let obj2 = document.getElementById('effective')
        obj.setAttribute('class', 'tab-bk active')
        obj2.setAttribute('class', 'tab-bk inactive')
        this.tabIndex = 1
        this.confirmNum = -1
        this.validList = []
        this.confirmList = []
        this.firstLoad = true
        this.fetchData()
      }
    }
  }
}

</script>

<style lang="less" scoped>
  .earnDetailsPage {
    padding-top: 50px;
    max-height: calc(100vh - 10px);
    overflow:hidden;
    .earnTab{
      display: flex;
      margin: 2vh auto 0vh auto;
      width: 91.82vw;
      height: 6.65vh;
      //border: 1px solid rgba(98, 98, 98, 1);
      border-radius: 3.5vh;
      .invite-tab{
        display: flex;
        width: 45.91vw;
        text-align: center;
        font-size: 1.8vh;
        font-weight: 700;
        .tab-bk{
          margin: auto;
          width: 42vw;
          height: 4.80vh;
          line-height: 4.80vh;
          border-radius: 2.5vh;
        }
        .active{
          color: #000000;
          background: linear-gradient(0deg, #FBFFCD, #FBFFCD), #EBFF0B;
        }
        .inactive{
          color: #ffffff;
          background:none;
        }
      }
    }
    .noDataAvailable {
      font-size: 2.28vh;
      color: #696969;
      text-align: center;
    }
    .dataList{
      margin:2.5vh auto;
      width: 90.39vw;
      height: 78vh;
      overflow-x: hidden;
      overflow-y: auto;
      .memos{
        display: flex;
        .memo {
          margin: 0vh auto 2.5vh auto;
          padding: 2vw 0;
          width: 90.38vw;
          height: 32.425vw;
          border-radius: 1.944vw;
          background: #262626;
          .item-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
          }
          .item-center {
            display: flex;
            flex-direction: column;
            flex: 1;
            background: linear-gradient(180deg, #1A1A1A 33.5%, #232323 100%);
            margin-top: 3.611vw;
            margin-left: 2.083vw;
            margin-right: 2.083vw;
            padding-bottom: 3vw;
            border-radius: 1.944vw;
            .total-list {
              display: flex;
              align-items: center;
              justify-content: space-between;
              position: relative;
              top: 0.8vh;
              left: 50%;
              width: 100%;
              transform: translate(-50%);
              .total-content {
              width: 21.65vw;
              text-align: center;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              gap: 0.55vw;
              .TotalTitle {
                display: flex;
                align-items: center;
                justify-content: center;
                line-height: 4vw;;
                height: 8.444vw;
                letter-spacing: -0.035em;
                font-weight: 500;
                text-align: center;
                text-transform: capitalize;
                color: #A9A9A9;
                font-size: 4.166vw;
                width: max-content;
                text-align: center;
              }

              .TotalVal {
                margin-top: 0.75vw;
                color: #ffffff;
                white-space: nowrap;
                font-weight: 600;
                font-size: 4.089vw;
                line-height: 4.9vw;
                letter-spacing: -0.03em;
              }

              .statusEN {
                margin-top: 0.9vw;
                margin-right: 2.638vw;
                width:60.888vw;
                font-size: 3.888vw;
                line-height: 6.762vw;
                font-weight: 500;
                text-align: right;
                color: #FF0000;
                position: relative;
                right: 15vw;
              }

              .statusIN {
                margin-top: 0.95vw;
                width: 54.888vw;
                font-size: 3.888vw;
                line-height: 6.75vw;
                font-weight: 500;
                text-align: left;
                color: #FF0000;
                margin-right: 2.638vw;
                position: relative;
                right: 10vw;
              }
            }
            }
          }
          .item-name{
            width: 42%;
            margin-left: 3.611vw;
            text-align: left;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-family: 'Inter';
            font-style: normal;
            font-weight: 500;
            font-size: 4.8vw;
            text-transform: capitalize;
            color: #FFFFFF;
          }
          .item-date{
            margin: 1.5vw 3.9vw 0 0;
            font-size: 3.68vw;
            font-weight: 400;
            text-align: left;
            letter-spacing: -0.05em;
            color: #646464;
          }
          .item-dateEN{
            margin: 0 5vw;
            font-size: 3.68vw;
            font-weight: 400;
            text-align: left;
            letter-spacing: -0.05em;
            color: #646464;
          }
          .item-dateIN{
            margin: 0 5vw;
            font-size: 3.68vw;
            font-weight: 400;
            text-align: left;
            letter-spacing: -0.05em;
            color: #646464;
          }
        }
      }
    }
    .dataList::-webkit-scrollbar{display:none}
  }
</style>



// WEBPACK FOOTER //
// src/pages/Invitee/details.vue